/** PostHog event names — keep explicit; no autocapture. */
export const AnalyticsEvent = {
  pageview: '$pageview',
  templatePreviewed: 'template_previewed',
  templateUsed: 'template_used',
  deckCreated: 'deck_created',
  deckSaved: 'deck_saved',
  deckExported: 'deck_exported',
  aiPromptSubmitted: 'ai_prompt_submitted',
  aiUpgradePromptShown: 'ai_upgrade_prompt_shown',
  pricingViewed: 'pricing_viewed',
  checkoutStarted: 'checkout_started',
  checkoutCompleted: 'checkout_completed',
  signupCompleted: 'signup_completed',
  loginCompleted: 'login_completed',
  loginDrawerOpened: 'login_drawer_opened',
} as const;

export type AnalyticsEventName = (typeof AnalyticsEvent)[keyof typeof AnalyticsEvent];

export type DeckCreatedSource = 'templates_page' | 'new_deck_page' | 'post_login';

export interface DeckCreatedProperties {
  template_id: string;
  slide_count: number;
  source: DeckCreatedSource;
}

export interface AiPromptProperties {
  plan: string;
  slide_count: number;
  success: boolean;
  error_message?: string;
}
